/* Maddie & Ko — theme.js
   - Welcome popup with sessionStorage
   - Hero slideshow dot sync
   - Filter chip toggle
   - Mini cart count refresh after add-to-cart
*/

(function () {
  'use strict';

  // ===== Welcome popup =====
  document.addEventListener('DOMContentLoaded', function () {
    var popup = document.getElementById('welcome-popup');
    if (popup && !sessionStorage.getItem('mk_seen_popup')) {
      setTimeout(function () { popup.classList.add('active'); }, 4000);
    }
    var closeBtn = document.getElementById('popup-close');
    var skipBtn = document.getElementById('popup-skip');
    function closePopup() {
      if (popup) popup.classList.remove('active');
      sessionStorage.setItem('mk_seen_popup', '1');
    }
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (skipBtn) skipBtn.addEventListener('click', closePopup);

    // Hero slideshow dot sync (visual indicator only; CSS handles the animation)
    var dots = document.querySelectorAll('.hero-dots span');
    if (dots.length) {
      var idx = 0;
      setInterval(function () {
        dots.forEach(function (d) { d.classList.remove('active'); });
        idx = (idx + 1) % dots.length;
        dots[idx].classList.add('active');
      }, 6000);
    }

    // Filter chip active state (visual only on homepage; collection page uses real links)
    document.querySelectorAll('.filter-row[data-decorative] .filter-chip').forEach(function (chip) {
      chip.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll('.filter-row[data-decorative] .filter-chip')
          .forEach(function (c) { c.classList.remove('active'); });
        chip.classList.add('active');
      });
    });

    // Quantity inputs
    document.querySelectorAll('.qty-input').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      var minus = wrap.querySelector('.qty-minus');
      var plus = wrap.querySelector('.qty-plus');
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });
    });

    // Refresh cart count after AJAX add-to-cart (if any forms post via fetch)
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function () {
        // Allow native submission. After page reloads, count is rendered server-side.
        // For instant feedback without reload, themes typically intercept and use fetch.
        // Keeping native submit here for simplicity.
      });
    });
  });

  // Helper: refetch cart count via /cart.js (useful if you later add AJAX add-to-cart)
  window.MaddieKo = {
    refreshCart: function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var el = document.querySelector('.cart-count');
          if (el) {
            el.textContent = cart.item_count;
            el.setAttribute('data-count', cart.item_count);
          }
        })
        .catch(function () { /* ignore */ });
    }
  };
})();
